export default __webpack_public_path__ + "static/media/babyDress.b9998cea.jpg";